/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Available_In_X_DaysInputs */

const en_available_in_x_days = /** @type {(inputs: Available_In_X_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Available in ${i?.number} days`)
};

const ar_available_in_x_days = /** @type {(inputs: Available_In_X_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`متاح بعد ${i?.number} أيام`)
};

const de_available_in_x_days = /** @type {(inputs: Available_In_X_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Verfügbar in ${i?.number} Tagen`)
};

const es_available_in_x_days = /** @type {(inputs: Available_In_X_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Disponible en ${i?.number} días`)
};

const fr_available_in_x_days = /** @type {(inputs: Available_In_X_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Disponible dans ${i?.number} jours`)
};

const it_available_in_x_days = /** @type {(inputs: Available_In_X_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Disponibile tra ${i?.number} giorni`)
};

const ja_available_in_x_days = /** @type {(inputs: Available_In_X_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number}日後に利用可能`)
};

const ko_available_in_x_days = /** @type {(inputs: Available_In_X_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number}일 후 사용 가능`)
};

const pt_br_available_in_x_days = /** @type {(inputs: Available_In_X_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Disponível em ${i?.number} dias`)
};

const ru_available_in_x_days = /** @type {(inputs: Available_In_X_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Доступно через ${i?.number} дней`)
};

const th_available_in_x_days = /** @type {(inputs: Available_In_X_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`พร้อมใช้งานในอีก ${i?.number} วัน`)
};

const tr_available_in_x_days = /** @type {(inputs: Available_In_X_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number} gün içinde kullanılabilir`)
};

const zh_cn_available_in_x_days = /** @type {(inputs: Available_In_X_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number} 天后开放`)
};

const zh_tw_available_in_x_days = /** @type {(inputs: Available_In_X_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number} 天後開放`)
};

/**
* | output |
* | --- |
* | "Available in {number} days" |
*
* @param {Available_In_X_DaysInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const available_in_x_days = /** @type {((inputs: Available_In_X_DaysInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Available_In_X_DaysInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_available_in_x_days(inputs)
	if (locale === "ar") return ar_available_in_x_days(inputs)
	if (locale === "de") return de_available_in_x_days(inputs)
	if (locale === "es") return es_available_in_x_days(inputs)
	if (locale === "fr") return fr_available_in_x_days(inputs)
	if (locale === "it") return it_available_in_x_days(inputs)
	if (locale === "ja") return ja_available_in_x_days(inputs)
	if (locale === "ko") return ko_available_in_x_days(inputs)
	if (locale === "pt_br") return pt_br_available_in_x_days(inputs)
	if (locale === "ru") return ru_available_in_x_days(inputs)
	if (locale === "th") return th_available_in_x_days(inputs)
	if (locale === "tr") return tr_available_in_x_days(inputs)
	if (locale === "zh_cn") return zh_cn_available_in_x_days(inputs)
	return zh_tw_available_in_x_days(inputs)
});